import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { IChatMessage } from '../../../../model/chatmessage';

export interface IActions {
	addMessage: (chatmessage: IChatMessage) => void;
	getChatMessages: (sub: string) => void;
	receiveMessageWebSocket: (chatmessage: IChatMessage, currentUserSub: string) => void;
	setChatMessagesAsSeen: (sub: string) => void;
	restNewMessageReceivedStatus: () => void;
	setNewMessageReceivedStatus: () => void;
	getUnreadCount: () => void;
}


export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
	return {
		addMessage: (chatmessage: IChatMessage) => {
			dispatch({
				type: Keys.ADDCHATMESSAGE,
				payload: invokeApi({
					path: '/api/Chat',
					method: 'POST',
					body: chatmessage,
					responseType: 'json'
				})
			})
		},
		getChatMessages: (sub: string) => {
			dispatch({
				type: Keys.GETCHATMESSAGES,
				payload: invokeApi({
					path: '/api/Chat?sub=' + sub,
					method: 'GET',
					responseType: 'json'
				})
			})
		},
		receiveMessageWebSocket: (chatmessage: IChatMessage, currentUserSub: string) => {
			dispatch({
				type: Keys.RECEIVEMESSAGEWEBSOCKET,
				payload: {
					chatmessage,
					currentUserSub
				}
			})
		},
		setChatMessagesAsSeen: (sub: string) => {
			dispatch({
				type: Keys.SETASSEEN,
				payload: invokeApi({
					path: `/api/Chat/SetMessagesAsSeen/${sub}`,
					method: 'PATCH',
					responseType: 'text'
				})
			})
		},
		getUnreadCount: () => {
			dispatch({
				type: Keys.GETCHATUNREADCOUNT,
				payload: invokeApi({
					path: '/api/Chat/unreadcount',
					method: 'GET',
					responseType: 'json'
				})
			})
		},
		restNewMessageReceivedStatus: () => {
			dispatch({
				type: Keys.RESETNEWMESSAGERECEIVEDSTATUS
			})
		},
		setNewMessageReceivedStatus: () => {
			dispatch({
				type: Keys.SETNEWMESSAGERECEIVEDSTATUS
			})
		}
	}
}